import OrgNodeCategory from './orgNodeCategory/orgNodeCategory'
import Organization from './organization/organization';
import OrgAuthorityManagement from './organization/orgAuthorityManagement/orgAuthorityManagement';
import OrganizationFileImport from './organization/organizationFile/organizationFileImport';
import PositionManager from  './position/positionManager';
import PositionDetail from './position/positionEdit/positionDetail'
import PositionCategoryManager from './positionCategory/positionCategoryManager';
import PersonInfoDetail from './person/personInfoDetail/personInfoDetail';
import PersonManage from './person/personManage';
import PersonDetail from './person/personDetail';
import ImportTemporary from './person/importTemporary';
import ImportSchoolCooperationPerson from './person/importSchoolCooperationPerson';
import ImportPerson from './person/importPerson';
import AdministrationScope from './person/administrationScope/administrationScope'
import PersonFaceAuthDetail from "./person/personFaceAuth/personFaceAuthDetail";
// import AddPerson from './person/addPerson/addPerson';
import DealerManager from './dealer/dealerManager';
import DealerDetail from './dealer/dealerEdit/dealerDetail';
import DealerInfoDetail from './dealer/dealerInfoDetail/dealerInfoDetail';
import DealerUnionManager from './dealerUnion/dealerUnionManager';
import DealerUnionFileImport from './dealerUnion/dealerUnionFile/dealerUnionFileImport';
import AbilityAssess from './abilityAssess/index'
import OrganizationZoneCode from './zoneCode/zoneCodeManager';
import OrganizationZoneCodeDetail from './zoneCode/OrganizationZoneCodeDetail';

import ManagerPermissionsSettingManager from './managerPermissionsSetting/managerPermissionsSettingManager'

export {
  OrgNodeCategory,
  OrganizationFileImport,
  Organization,
  PositionManager,
  PositionDetail,
  PositionCategoryManager,
  OrgAuthorityManagement,
  PersonInfoDetail,
  PersonManage,
  DealerInfoDetail,
  PersonDetail,
  // AddPerson,
  DealerManager,
  DealerDetail,
  DealerUnionManager,
  AdministrationScope,
  DealerUnionFileImport,
  AbilityAssess,
  ImportTemporary,
  OrganizationZoneCode,
  OrganizationZoneCodeDetail,
  PersonFaceAuthDetail,
  ImportSchoolCooperationPerson,
  ImportPerson,
  ManagerPermissionsSettingManager
}
